module.exports = require('./internal/FixedDataTableRoot');
